<template>
  <div id="xtglwxpart">
   <div class="sjmydesh">
      <img src="../../assets/zzkfz.png" alt="">
      <p>正在开发中......敬请期待~</p>
   </div>
  </div>
  </template>
  <script>
     export default {
     name:'xtglwxpart',
     data(){
      return{
      }
     },
     created(){
     },
     mounted(){
     },
     methods:{
     }
     }
  </script>
  <style scoped>
   #xtglwxpart {
     width: 100%;
     height: 100%;
     overflow-y: auto;
     background-color: #fff;
     padding:0 0 0 30px;
     box-sizing: border-box;
     display: flex;
     justify-content: center; /* 水平居中 */
     align-items: center; /* 垂直居中 */
   }
   .sjmydesh {
     margin: auto; /* 水平和垂直居中 */
     text-align: center;
   }
   .sjmydesh img{
     width: 748px;
     height: 402px;
     margin: -200px 0 100px 0;
   }
  </style>


// WEBPACK FOOTER //
// src/components/xtglwxpart/xtglwxpart.vue